import { Text as FluentText } from "@fluentui/web-components";
/**
 * Text
 * @summary A Text Custom HTML Element based on Fluent UI's Text with custom styling and behavior.
 *
 * @example
 * ```html
 * <fabric-text nowrap size="700" weight="bold" align="center">
 *   Your text here
 * </fabric-text>
 * ```
 *
 * @attr {boolean} nowrap - The text will not wrap. Boolean attributes which default to true in HTML can't be switched off in the DOM.
 * @attr {boolean} truncate - The text truncates.
 * @attr {boolean} italic - The text style is italic.
 * @attr {boolean} underline - The text style is underline.
 * @attr {boolean} strikethrough - The text style is strikethrough.
 * @attr {boolean} block - A text can take up the width of its container.
 * @attr {TextSize} size - The Text size. One of '100', '200', '300', '400', '500', '600', '700', '800', '900', '1000'.
 * @attr {TextFont} font - The Text font. One of 'base', 'numeric', 'monospace'.
 * @attr {TextWeight} weight - The Text weight. One of 'medium', 'regular', 'semibold', 'bold'.
 * @attr {TextAlign} align - The Text alignment. One of 'start', 'end', 'center', 'justify'.
 *
 * @prop {boolean} nowrap - The text will not wrap.
 * @prop {boolean} truncate - The text truncates.
 * @prop {boolean} italic - The text style is italic.
 * @prop {boolean} underline - The text style is underline.
 * @prop {boolean} strikethrough - The text style is strikethrough.
 * @prop {boolean} block - A text can take up the width of its container.
 * @prop {TextSize} size - The Text size.
 * @prop {TextFont} font - The Text font.
 * @prop {TextWeight} weight - The Text weight.
 * @prop {TextAlign} align - The Text alignment.
 *
 * @slot default - The default slot for text content.
 *
 * @extends FluentText
 * @tagname fabric-text
 * @public
 */
export class Text extends FluentText {
}
//# sourceMappingURL=text.js.map